import { reactive, ref } from 'vue'

export function useLoginFlow() {
  const currentStep = ref(null)
  const isLoading   = ref(false)

  const flowData = reactive({
    identifier:      '',
    identifierType:  '', // 'email' | 'phone'
    userType:        '', // 'patient' | 'practice' | 'admin'
    preferredMethod: null, // MFA_METHOD.SMS | MFA_METHOD.EMAIL | null
    hasPreferredMethod: false,
    mfaEnabled:     true,
    bypassMfa:       false,
    trustDevice:     false,
    magicLinkChannel: '',
    magicLinkExpired: false,
    resetLinkChannel: '',
    passwordResetRequired: false,
    resetToken:      '',
    verifyBackStep:  '',
    flowMode:        'modern',
    isTrustedDevice: false,
    isPasswordReset: false,
    passwordResetChannel: '',
  })

  const navigateTo = (step) => {
    currentStep.value = step
  }

  const setFlowData = (data) => {
    Object.assign(flowData, data)
  }

  return {
    currentStep,
    isLoading,
    flowData,
    navigateTo,
    setFlowData,
  }
}
